<template>
  <div>
    <div class="compilePhone-top"></div>
    <div class="compilePhone">
      <img
        class="compilePhone-img"
        src="https://img.yzcdn.cn/upload_files/2020/10/14/FiqqfsD9ZDZS3EHUjiWrNSNLKwoK.png"
       
      />
      <p class="compilePhone_title">已完成绑定</p>
      <p class="compilePhone_title" style="margin-top:0.21rem">
        目前绑定的手机为<span style="color:#E52F4B">{{ mobile }}</span>
      </p>
      <div class="compilePhone_back" @click="back">返回</div>
      <div class="compilePhone_qie" @click="toPhone">更换手机号</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompilePhone',
  data() {
    return {}
  },
  computed: {
    mobile() {
      return this.$store.userInfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    toPhone() {
      // location.href =
      //   '/cms/webapp/home/user/user_center.html#/reBindPhoneNumber?bind=1&channel=' +
      //   this.$route.query.channel +
      //   '&id=' +
      //   this.$route.query.id
      this.$router.push({
        path:
          '/rebindPhone?bind=1&jifen=1&channel=' +
          this.$route.query.channel +
          '&id=' +
          this.$route.query.id
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.compilePhone-top {
  width: 100vw;
  height: 0.18rem;
  background-color: #f3f3f3;
}
.compilePhone {
  text-align: center;
  background-color: #ffffff;
  .compilePhone-img {
    width: 1.72rem;
    height: 1.9rem;
    display: inline-block;
    margin-top: 1.32rem;
    margin-bottom: 0.68rem;
  }
  .compilePhone_title {
    font-size: 0.4rem;
  }
  .compilePhone_back {
    width: 7.29rem;
    height: 1.15rem;
    border-radius: 0.57rem;
    font-size: 0.4rem;
    background-color: #e52f4b;
    color: #ffffff;
    text-align: center;
    line-height: 1.15rem;
    margin-top: 1.7rem;
    margin-bottom: 0.53rem;
    display: inline-block;
  }
  .compilePhone_qie {
    text-align: center;
    font-size: 0.4rem;
    color: #e52f4b;
  }
}
</style>
